/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Commission_Void_Dialog_DescInputs */



/**
* | output |
* | --- |
* | "Voiding {count} entries (net {amount}). This removes them from the payable ledger. A reason is required." |
*
* @param {Partner_Admin_Commission_Void_Dialog_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_void_dialog_desc = /** @type {((inputs: Partner_Admin_Commission_Void_Dialog_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Void_Dialog_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Einträge werden storniert (netto ${i?.amount}). Dadurch werden sie aus dem zahlbaren Journal entfernt. Ein Grund ist erforderlich.`)
	return /** @type {LocalizedString} */ (`Voiding ${i?.count} entries (net ${i?.amount}). This removes them from the payable ledger. A reason is required.`)
});